import{svg as s}from"lit";import{unsafeSVG as o}from"lit/directives/unsafe-svg.js";var p=(m,e,r,n=e,t=r)=>s`<svg width="${e}" height="${r}" viewBox="0 0 ${n} ${t}" fill="none" xmlns="http://www.w3.org/2000/svg">${o(m)}</svg>`;export{p as a};
//# sourceMappingURL=chunk.OZB5OUAY.js.map
